import { buildProps } from '@xzx-design/utils'

import type { ExtractPropTypes } from 'vue-demi' // test vue-demi
import type Step from './step.vue'

export const stepProps = buildProps({
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  icon: {},
  /**
   * @description 当前步骤状态
   */
  status: {
    type: String,
    values: ['', 'wait', 'process', 'finish', 'error'],
    default: '',
  },
})

export type StepProps = ExtractPropTypes<typeof stepProps>
export type StepInstance = InstanceType<typeof Step>
